const messages = {
    fields: {
        first_name: 'Vorname',
        last_name: 'Nachname',
        address: 'Straße',
        postcode: 'PLZ',
        city: 'Wohnort',
        phone: 'Telefonnummer',
        house_number: 'Hausnummer',
        password: 'Passwort',
    },
    customPages: {
        mainCategory: 'Hauptkategorien',
    },
    validations: {
        required: 'Bitte {field} überprüfen',
        invalid: 'Bitte {field} überprüfen',
    },
    blockCart: {
        addToCart: 'Zum Warenkorb hinzufügen',
        addedToCartTitle: 'Ihrem Warenkorb hinzugefügt',
        continueShopping: 'Weiter einkaufen',
        proceedToCheckout: 'Warenkorb',
        productTotal: 'Gesamtpreis',
        showAllProducts: 'Alle Produkte anzeigen',
        cartShipping: 'Versandkosten',
        cartTotal: 'Gesamtpreis',
        close: 'Schließen',
        addedToCartChoiceTitle: 'Ihre Auswahl:',
        noItemSelected: 'Keine Auswahl getroffen!',
        frequentlyBoughtTogether: 'Häufig zusammen gekauft'
    },
    myAccount: {
        titlePersonalInformation: 'Meine Daten',
        adjustData: 'Daten ändern',
        setNewPassword: 'Neues Passwort festlegen?',
        phoneNumberMessage: 'Zur Kontaktaufnahme durch DPD',
        houseNumber: 'Hausnummer',
        optional: 'Optional',
        currentPassword: 'Aktuelles Passwort',
        newPassword: 'Neues Passwort',
        email: 'E-Mail-Adresse',
        titleOrderHistory: 'Bestellungen',
        logout: 'Ausloggen',
        loading: 'Laden...',
        yourCart: 'Ihr Warenkorb',
        address2: 'Adresszusatz',
        addAddress: 'Adresse hinzufügen',
        defaultAddress: 'Standard Adressse',
        setAsDefaultAddress: 'Standard Adressse',
        adjust: 'Anpassen',
        name: 'Name',
        firstName: 'Vorname',
        lastName: 'Nachname',
        address: 'Straße',
        zipcode: 'Postleitzahl',
        residence: 'Wohnort',
        country: 'Land',
        phone: 'Telefon',
        phoneNumber: 'Telefonnummer',
        copyAddress: 'Adresse kopieren',
        delete: 'Löschen',
        errorMessage: 'Ups! Fehler entdeckt.',
        cancel: 'Abbrechen',
        save: 'Speichern',
        packaging: 'Verpackung',
        unitPrice: 'Stückpreis',
        price: 'Preis',
        totalPriceProducts: 'Gesamtpreis der bestellten Produkte',
        total: 'Gesamtpreis',
        freeOfCharge: 'Kostenlos',
        taxIncl: 'Inkl. MwSt.',
        continueToOrder: 'Zur Kasse',
        easyReorder: 'Einfach nachbestellen!',
        easyReorderMessage: 'Produkte aus früheren Bestellungen hinzufügen.',
        emtpyOrderMessage:
            'Wenn Sie eine Bestellung aufgegeben haben, erscheint sie hier mit Informationen über die Lieferzeit, Ihre Rechnung usw. Von dieser Seite aus können Sie auch problemlos frühere Bestellungen nachbestellen.',
        emtpyOrderMessage2: 'klicken',
        emtpyOrderMessage3: 'hier',
        emtpyOrderMessage4: ' um zur Homepage zu gelangen.',
        reorder: 'Nachbestellen',
        products: 'Produkt(e)',
        totalShipmentCost: 'Versandkosten gesamt',
        shipmentCost: 'Versandkosten',
        status: 'Status',
        detailsInvoice: 'Einzelheiten & Rechnung',
        downloadInvoice: 'Rechnung herunterladen ',
        shippedBy: 'Versendet von',
        paymentMethod: 'Bezahlmethode',
        deleteAddressModalText: 'Sind Sie sicher, dass Sie diese Adresse löschen möchten?',
        deleteAddressModalLoaderText: 'Beschäftigt mit löschen?',
        errorModalText: 'Entschuldigung, etwas ist schief gelaufen',
        errorModalText2: 'Versuchen Sie es später noch einmal',
        appModalTitle: 'Brekz - Online Tiershop - App',
        appModalText:
            'Können Sie jederzeit alles für Ihr Haustier bestellen? Von nun an können Sie dies ganz einfach über die Brekz App.\\n' +
            'Tausende von Artikeln wie Lebensmittel, leckere Snacks und lustiges Spielzeug einfach an einem Ort bestellen.',
        appModalText2: 'Sie finden die App im Play Store und App Store',
        appModalListTitle: 'Vorteile',
        appModalListItem: '- Immer Ihre Tierhandlung zur Hand',
        appModalListItem1: ' - Einfach und schnell nachbestellen',
        appModalListItem2: '- Handy-Benachrichtigungen über Bestellungen und',
        appModalListItem3: '- Legen Sie fest, welche \\/ wie viele Benachrichtigungen Sie erhalten möchten',
        appModalListItemLink: 'Angebote',
        reorderModalSorry: 'Leider nicht auf Lager',
        reorderModalOutOfStock: 'Nicht lieferbar',
        reorderModalPackaging: 'Die folgende Packung ist nicht lieferbar',
        reorderModalSkip: 'Überspringen Sie dieses Produkt',
        reorderModalAlternativesInStock: 'Vorrätige Alternativen',
        reorderModalQuantity: 'Menge',
        pricePerUnit: 'Preis pro Stück',
        addProduct: 'Hinzufügen',
        bundleDiscount: 'Bundle Ersparnis',
        discount: 'Gespart',
        reorderModalOrderAlternative: 'Alternativ bestellen',
        saveConfirmationModalTitle: 'Ihre Daten wurden gespeichert',
        minimumPurchaseMessage:
            'Der Mindestbestellwert beträgt {amount} (exkl. Versandkosten). Fügen Sie 1 oder mehrere Produkte zu Ihrem Warenkorb hinzu um fortzufahren.',
        trackAndTraceText: 'Verfolgen Sie Ihre Bestellung (verfügbar nach Versand Ihres Pakets)',
        noAlternativeProducts: 'Leider gibt es keine alternativen Verpackungen für Ihre vorherige Bestellung',
        addressDescription: 'Hier ist eine Übersicht über Ihre Adressdaten. Sie können diese hier bearbeiten.',
        titleMyOrders: 'Meine Bestellungen',
        orderDescription: 'Prüfen Sie den Status Ihrer Bestellung, Ihre Rechnung oder bestellen Sie einfach nach\n',
        orderDescriptionShort: 'Prüfen Sie hier den Status Ihrer Bestellung',
        addresses: 'Meine Adressen',
        okay: 'Okay',
        errorFirstName: 'Tragen Sie den Vornamen korrekt ein.',
        errorLastName: 'Tragen Sie den Nachnamen korrekt ein.',
        errorEmail: 'E-Mail-Adresse korrekt eintragen',
        errorPhone: 'Kontrollieren Sie Ihre Telefonnummer',
        errorAddress: 'Kontrollieren Sie Ihre Straße & Hausnummer (Nummer im folgenden Kästchen)',
        errorAddress2: 'Kontrollieren Sie Ihre Straße & Hausnummer (Nummer im folgenden Kästchen)',
        errorZipcode: 'Falsche Postleitzahl',
        errorCity: 'Kontrollieren Sie Ihren Wohnort',
        errorPassword: 'Wachtwoord ontbreekt of is te kort',
        eraseWarning: 'Sie sind dabei, alle von Ihnen eingegebenen Daten zu löschen!',
        eraseConfirmation: 'Sind Sie sicher?',
        amount: 'Nummer',
        orderDate: 'Bestelldatum',
        trackAndTrace: 'Track & Trace',
        close: 'Schließen',
        toCart: 'Zum Warenkorb',
        productsInCart: 'Produkte wurden dem Warenkorb hinzugefügt',
        orderInCart: 'Ihre Bestellung wurde dem Warenkorb hinzugefügt',
        productsInColumn:
            'Sie finden sie in der rechten Spalte auf dieser Seite, oder klicken Sie auf das Warenkorb-Symbol oben rechts auf der Seite',
        orderStatus: 'Status Ihrer Bestellung',
        orderProcess: 'Ihre Bestellung durchläuft In den meisten Fällen folgende Schritte:',
        paymentWaiting: 'Warten auf Ihre Bezahlung',
        paymentReceived: 'Zahlung erhalten',
        orderCollected: 'Bestellung wird gesammelt',
        orderSent: 'Ihre Bestellung wurde versandt',
        followOrder: 'Sie können Ihr Paket jetzt über ',
        followOrderEnd: ' verfolgen.',
        multiplePackages: 'Hinweis: Bestellung enthält mehrere Pakete',
        trackAndTraceActiveTime: 'Hinweis: Es kann etwas dauern, bis der Link aktiv wird',
        delivered: 'Geliefert',
        password: 'Password',
        didYouMean: 'Meinen Sie vielleicht',
        apply: 'Bewerbung',
        bundle: 'Bündel',
        bundlePriceWas: 'War',
        saving: 'Sie sparen',
    },
    checkout: {
        between: '',
        and: ' - ',
        days: "Werktage",
        delivery: 'Lieferung',
        countdownMessage1: 'Bestellen Sie innerhalb von',
        countdownMessage2: 'für die schnellste Lieferung',
        newCard: 'Neue Kreditkarte verwenden',
        creditCard: 'Kreditkarte',
        addNewCard: 'Neue {card} hinzufügen',
        passwordMessage: 'Mindestens 5 Zeichen',
        loading: 'Laden...',
        lastStep: 'Letzter Schritt',
        savedCard: 'Gespeicherte {card} verwenden',
        cardNumber: 'Kartennummer',
        otherCard: 'Andere {card} verwenden',
        expireDate: 'Ablaufdatum',
        errorCard: 'Diese Karte ist nicht gültig oder wird nicht unterstützt',
        errorName: 'Ungültiger Name',
        errorDate: 'Ablaufdatum ist ungültig oder überschritten',
        errorCVV: 'Ungültiger CVV',
        cardExpired: 'Diese Karte ist in unserem System abgelaufen. Bitte geben Sie die Karteninformationen erneut an.',
        saveCard: '{card} speichern',
        nextTime: 'für nächstes Mal',
        order: 'Bestellen',
        back: 'Zurück zu Bezahlmethoden',
        addressEdit: 'Vorhandene Adresse ändern',
        paymentSucces: 'Wir haben Ihre Bezahlung empfangen',
        backToOrderhistory: 'In einigen Sekunden werden Sie zur Bestellübersicht weitergeleitet',
        bancontactNotAvailable: 'Bancontact steht für DE nicht zur verfügung',
        allData: 'Ihre Daten sind',
        secured: 'sicher',
        almostDone: 'Beinahe abgeschlossen',
        banContactNotAvailable: 'Bancontact is niet beschiktbaar op',
        payWith: 'Reken af met uw',
        bancontactApp: 'Bancontact app',
        useOtherBancontact: 'Andere Bancontact gebruiken',
        useNewBancontact: 'Nieuwe Bancontact gebruiken',
        addNewBancontact: 'Nieuwe Bancontact toevoegen',
        payWithBancontactApp: 'Betaal met de bancontact App',
        openBancontactApp: 'Open de bancontact app en scan de code om de betaling met de app af te ronden',
        noBancontactApp: 'Heeft u de app niet? Gebruik dan de methode hiernaast.',
        mistercacheSave: 'Bancontact opslaan',
        cardHolderNamePlaceholder: 'M. MUSTERMANN',
        newAccount: 'Ihre persönlichen Daten',
        cancel: 'Abbrechen',
        taxIncl: 'Inkl. MwSt.',
        total: 'Gesamtpreis',
        name: 'Name',
        close: 'Sluiten',
        errorText: 'Entschuldigung, etwas ist schief gelaufen',
        errorModalText: 'Entschuldigung, etwas ist schief gelaufen',
        errorModalText2: 'Versuchen Sie es später noch einmal',
        rememberAddressHeaderTitle: 'Sparen Sie Zeit bei Ihrem nächsten Einkauf',
        rememberAddressSwitchLabel: 'Verwenden Sie bei der nächsten Bestellung diese Adresse und Bezahlmethode',
        paymentSecurityText: 'Alle Ihre Daten sind',
        paymentSecurityTextBold: 'sicher',
        paymentCardHeaderTitle: 'Zahlungsarten',
        addressCardHeaderTitle: 'Lieferadresse',
        invoiceAddress: 'Adresse der Rechnung',
        editAddress: 'Anpassen',
        addNewAddress: 'Neue Adresse hinzufügen',
        addNewInvoiceAddress: 'Neue Rechnungsadresse hinzufügen',
        addressMatchesInvoiceAddress: 'Rechnungsadresse stimmt mit Lieferadresse überein',
        addressMatchesNotInvoiceAddress: 'Rechnungsadresse stimmt nicht überein mit Lieferadresse',
        // checkout progressbar
        progressbarLogIn: 'Einloggen',
        progressbarPaymentOption: 'Zahlungsart',
        progressbarPayment: 'Zahlung',
        progressbarDone: 'Fertig!',
        klarnaPhoneNumberRequiredModal: {
            modalMessage:
                'Sie haben sich entschieden, im Nachhinein mit <strong>Klarna</strong> zu bezahlen. Hierfür wird Ihre Telefonnummer benötigt.',
            phoneNumberInputField: 'Geben Sie hier Ihre Telefonnummer ein',
            otherPaymentMethod: 'Andere Zahlungsart wählen',
        },
        validationErrors: {
            noPaymentMethodSelected: 'Sie haben noch keine Zahlungsart ausgewählt',
            noAddressSelected: 'Sie haben noch keine Liefer- und/oder Rechnungsadresse ausgewählt',
            paymentMethodRequiresPhoneNumber:
                'In Ihren Adressdaten fehlt Ihre Telefonnummer. Fügen Sie diese hinzu, um mit Klarna bezahlen zu können.',
            termsOfServices: 'Bitte akzeptieren Sie die Nutzungsbedingungen.',
            noDeliveryOnThisAddress:
                'Leider können wir nicht an die von Ihnen angegebene Postleitzahl liefern. Bei der Bestellung können Sie auswählen, dass das Paket an eine andere Postleitzahl geliefert werden soll.',
        },
        processWaiting: {
            title: 'Zahlung wird verarbeitet',
            description: 'Bitte haben Sie einen Moment Geduld',
        },
    },
    address: {
        placeholderFirstname: 'Jan',
        placeholderLastname: 'Janssen',
        placeholderAddress: 'Hauptstraße ',
        placeholderAddress2: 'Stockwerk, Unternehmen, Ortsteil',
        placeholderZipcode: '12345',
        placeholderCity: 'Berlin',
        placeholderPhone: '0151567890',
        noShipping:
            'Für die von Ihnen gewählte Postleitzahl fallen leider zusätzliche Versandkosten an. Um diese Kosten zu vermeiden, können Sie das Paket an eine andere Postleitzahl zustellen lassen.',
    },
    outOfStockNotificationOptin: {
        modalTitle: 'Halten Sie mich auf dem Laufenden',
        modalMessage: 'Sie erhalten eine E-mail, sobald das Produkt wieder verfügbar ist.',
        modalSubmitButton: 'Halten Sie mich auf dem Laufenden',
        email: 'E-Mail-Adresse',
        placeholderEmail: 'vorschau@email.com',
        noAbuse: 'Ihre E-Mail-Adresse wird für keine anderen Zwecke verwendet werden.',
        alreadySignedUp: 'Sie haben sich bereits für eine E-Mail-Benachrichtigung für dieses Produkt angemeldet.',
        invalidEmail: 'Ungültige E-Mail-Adresse',
        genericError: 'Es ist ein Fehler aufgetreten',
    },
    orderConfirmation: {
        modalTitle: 'Möchten Sie Ihre Bestellung verfolgen?',
        modalMessage:
            'Sie haben als Gast bestellt. Wenn Sie ein Passwort hinzufügen, können Sie Ihre Bestellung in der Bestellübersicht in Ihrem persönlichen Account verfolgen.',
        enterPassword: 'Passwort hinzufügen',
        minimumWarning: 'Mindestens fünf Zeichen',
        passwordTooShort: 'Das eingegebene Passwort ist zu kurz',
        somethingWentWrong: 'Es ist ein allgemeiner Fehler aufgetreten',
    },
    unsubPage: {
        emailQuestion: 'Für welche E-Mail-Adresse?',
        emailKnown: 'E-Mail-Adresse von Ihrem Konto: ',
        emailadres: 'E-Mail-Adresse:',
        changeEmailSettings: 'E-Mail-Einstellungen anpassen',
        iWant: 'Ich möchte',
        iWant2: 'Ich möchte',
        keepProfiting: 'weiterhin',
        ofTheBenefitMail: 'von den E-Mails mit Vorteilsangeboten profitieren',
        sendMe: 'Senden Sie mir',
        onesEvery2Weeks: 'alle zwei Wochen ',
        exclusiveOffersAndTheBestDiscounts: 'exklusive Angebote und die besten Rabatte',
        onetimeAMonth: '1x im Monat ',
        wellEnoughButDontMiss: 'genügt, ich möchte aber trotzdem kein Rabattangebot verpassen',
        noBenefit: 'Ich möchte keine Rabattangebote mehr',
        writeMeOut: ', ich melde mich ab',
        benefitMail: 'E-Mail mit Vorteilangeboten',
        birthdayMail: 'Geburtstags-E-Mail',
        tipsAndAdvice: 'Tipps und Ratschläge',
        personalDiscount: 'Persönliche Rabatte',
        productReviewAndReviews: 'Produktbeurteilungen und Reviews',
        stillReceiveUpdatesAboutDelivery:
            'Sie erhalten selbstverständlich weiterhin Updates zu Ihren Bestellungen und Lieferungen',
        feedBackAndTips: 'Haben Sie Tipps oder Feedback für uns?',
        cancel: 'Abbrechen',
        benefitDogCat: 'Ein Vorteilsangebot für einen Hund oder eine Katze hinzufügen?',
        iWantBenefitFor: 'Ich möchte Rabattangebote für',
        dogs: 'Hunde',
        cats: 'Katzen ',
        dogsAncCats: 'Hunde und Katzen',
        no: 'keine',
        receiveMoreBenefitFor: 'Rabattangebote für',
        giveMe: 'Ich möchte gerne',
        allBenefit: 'alle Vorteilsangebote ',
        average2MailsAWeek: '(durchschnittlich 2 E-Mails mit Rabattangeboten pro Woche)',
        oneTime2Weeks: '1x alle zwei Wochen',
        save: 'Speichern Sie',
        received: '',
        selectVariant: 'Variante wählen',
        YouAreSuccessfullyUnsubscribedFor: 'Sie haben sich erfolgreich abgemeldet von:',
        checkYourEmail: 'Kontrollieren Sie Ihre E-Mail-Adresse',
        noOptionSelected: 'Es wurde keine Option ausgewählt',
    },
    algoliaSearch: {
        mqc: {
            max: 'Max',
            perCustomer: 'pro Kunde',
        },
        searchButton: 'Suchen',
        searchPlaceholder: 'Artikel suchen',
        searchBarInputPlaceholder: 'Artikel suchen',
        searchBarInputPlaceholderApp: '6000+ Producte',
        noResultsContentTitleCategory: 'Leider wurden mit den ausgewählten Filtern keine Produkte gefunden',
        noResultsContentTitle: 'Wir konnten für <span class="algolia-listing-no-results__content-title--brand">“{query}“</span> <b>keine Resultate</b> finden.',
        noResultsContentListTitle: 'Was Sie tun können:',
        noResultsContentListItemOne: 'Kontrollieren Sie Ihr Suchwort auf Rechtschreibung',
        noResultsContentListItemOneCategory: 'Löschen Sie ein oder mehrere Filter',
        noResultsContentListItemTwo:
            'Haben Sie einen Markennamen gesucht? Wir haben diese Marke leider (noch) nicht in unserem Sortiment',
        noResultsContentListItemTwoCategory: 'Klicken Sie auf `Alles löschen‘ um eine neue Auswahl zu starten',
        noResultsContentListItemThree: 'Probieren Sie es mit einem anderen Suchwort',
        noResultsWithQuery: 'Keine Vorschläge gefunden für <b>"{query}"</b>',
        searchHistoryTitle: 'Frühere Suchanfragen',
        searchResultsHeader: '<b>{resultCount}</b> resultaten voor <b>"{query}"</b> in alle artikelen.',
        searchResultsHeaderSubtitle: 'Verfijn uw resultaten met onderstaande filters.',
        searchResultsTitle: 'Suchvorschläge',
        popularProductsTitle: 'Favoriten',
        popularCategoriesTitle: 'Beliebte Kategorien',
        queryMirrorTitle: 'Ihre Suche',
        resultsHitsProducts: 'Artikel',
        resultsHitsDelete: 'Alles löschen',
        resultsHitsFilter: 'Filtern',
        resultsHitsFilterNote: 'Verwenden Sie Filter für ein schnelleres Ergebnis',
        fiterPanelMobileHeaderTitle: 'Filtern',
        fiterPanelMobileHeaderSubtext: 'Verwenden Sie Filter für ein schnelleres Ergebnis',
        fiterPanelMobileDeleteFilters: 'Alles löschen',
        fiterPanelMobileFilteredProductAmount: 'Artikel',
        fiterPanelMobileSaveSelection: 'Auswahl speichern',
        fiterPanelMobileFooterTextPartOne: 'Filter',
        fiterPanelMobileFooterTextPartTwo: 'Ergebnisse',
        hitItemFromLabel: 'ab',
        hitItemViewProduct: 'Artikel ansehen',
        refinementListViewMore: 'Mehr…',
        refinementListViewLess: 'Weniger...',
        refinementListRangeBoxInbetween: 'bis',
        unAvailableNotePartOne: 'ab dem',
        unAvailableNotePartTwo: 'wieder verfügbar',
        filters: {
            priceReduction: {
                on: 'Ja',
                off: 'Nein',
            },
        },
    },
    algoliaRecommend: {
        recommendedProducts: 'Ähnliche Produkte',
        recommendedProductsSubtitle: 'Anders, aber auch top!',
        boughtTogether: 'Oft zusammen gekauft',
        boughtTogetherSubtitle: 'Auf einen Schlag fertig!'
    },
    mobileMenu: {
        makeYourChoice: 'Treffen Sie Ihre Wahl',
    },
    combinationPromotion: {
        op: 'Begrenzter Vorrat',
        bonus: 'Bonusbag',
        twoPlusOneFree: '2 + 1 Gratis',
        minusTenPercent: '-10%',
        minusTwentyPercent: '-20%',
        minusTwentyFivePercent: '-25%',
        minusThirtyPercent: '-30%',
        minusFortyPercent: '-40%',
        minusFiftyPercent: '-50%',
        minusSixtyPercent: '-60%',
        minusSeventyPercent: '-70%',
    },
    resetPassword: {
        passwordError: 'Passwörter stimmen nicht überein',
        passwordForgot: 'Passwort vergessen?',
        createNewPassword: 'Neues Passwort erstellen',
        description:
            'Geben Sie die E-Mail-Adresse Ihres Kontos ein. Wir senden an diese E-Mail-Adresse einen Link, mit dem Sie ein neues Passwort anlegen können.',
        email: 'E-Mail-Adresse',
        note: 'Es kann eine Weile dauern, bis Sie den Link erhalten. Bitte warten Sie mindestens 4 Minuten, bevor Sie erneut einen Link anfordern. Dadurch wird verhindert, dass Sie einen nicht funktionierenden Link erhalten.',
        setNewPassword: 'Neues Passwort anlegen',
        chooseNewPassword: 'Wählen Sie ein neues Passwort',
        newPassword: 'Neues Passwort',
        reenterPassword: 'Geben Sie Ihr neues Passwort erneut ein',
        passwordsDontMatch: 'Passwort in Feld 2 entspricht nicht Feld 1',
        passwordsDontMatchError: 'Die Passwörter stimmen nicht überein',
        submit: 'Bestätigen',
    },
};
export default messages;
